/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetBoxesService,
  IGetBoxesMethods,
  ICreatePayTxMethods,
  CreatePayTxService,
  IUpdateBoxMethods,
  UpdateBoxService,
  UpdateValidEmailIDService,
  IUpdateValidEmailIDMethods,
  IGetInvoicePdfTypeMethods,
  GetInvoicePdfService,
  UpdateDelegateNameService,
  IShareInvoiceMethods,
  ShareInvoiceService,
  IUpdateDelegateNameMethods,
  IChangeModeMethods,
  ChangeModeService,
  TransferBoxService,
  ITransferBoxMethods,
  IAddBoxNoteMethods,
  AddBoxNoteService,
  ICheckPaymentFromPGTypeMethods,
  CheckPaymentFromPGService,
  IDeletePayTxTypeMethods,
  DeletePayTxService,
  IGetBoxesYearMethods,
  GetBoxesYearService,
  IGetPastPurchaseBoxesMethods,
  GetPastPurchaseBoxesService,
  ICreatePayFACMethods,
  CreatePayFACService,
  IValidateDiscountMethods,
  ValidateDiscountService,
  IRefundTransactionMethods,
  RefundTransactionService,
  IAdjustmentMethods,
  AdjustmentService,
  IGetCitiesMethods,
  GetCitiesService,
  IGetMyDiscountMethods,
  GetMyDiscountService
} from "./components";

export type MasqViewBoxPageAgent = IStaticPageContentMethods &
  IGetBoxesMethods &
  IGetMyDiscountMethods &
  IUpdateBoxMethods &
  ICreatePayTxMethods &
  IUpdateValidEmailIDMethods &
  IUpdateDelegateNameMethods &
  IChangeModeMethods &
  ITransferBoxMethods &
  IRefundTransactionMethods &
  IShareInvoiceMethods &
  IGetInvoicePdfTypeMethods &
  IAddBoxNoteMethods &
  IGetBoxesYearMethods &
  ICheckPaymentFromPGTypeMethods &
  IGetPastPurchaseBoxesMethods &
  IDeletePayTxTypeMethods &
  IValidateDiscountMethods &
  IAdjustmentMethods &
  IGetCitiesMethods &
  ICreatePayFACMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new UpdateBoxService(),
    new ShareInvoiceService(),
    new GetBoxesService(),
    new CreatePayTxService(),
    new GetMyDiscountService(),
    new UpdateValidEmailIDService(),
    new GetInvoicePdfService(),
    new UpdateDelegateNameService(),
    new ChangeModeService(),
    new TransferBoxService(),
    new GetBoxesYearService(),
    new AddBoxNoteService(),
    new RefundTransactionService(),
    new CheckPaymentFromPGService(),
    new GetPastPurchaseBoxesService(),
    new DeletePayTxService(),
    new GetCitiesService(),
    new CreatePayFACService(),
    new ValidateDiscountService(),
    new AdjustmentService(),
  ];
};

export const getAgent = () => {
  return createAgent<MasqViewBoxPageAgent>({
    plugins: getPlugins(),
  });
};
